<div class="d-flex flex-column justify-content-center flex-grow-1">
  <div *ngIf="checkLoginStatus()" class="container">
    <div class="row justify-content-center">
      <div class="col col-12 col-lg-8 col-xxl-6">
        <div class="card login-card">
          <div class="card-body">
            <h4 class="mb-3 display-4">Development Break-In</h4>

            <div *ngIf="login_error" class="alert alert-danger" role="alert">
              <span>There was an error logging in. Please check credentials and try again.</span>
            </div>

            <form class="d-flex flex-column" [formGroup]="form" (ngSubmit)="onRegisterSubmit()">
              <ul ngbNav #nav="ngbNav" [(activeId)]="current_tab" class="nav-tabs">
                <li [ngbNavItem]="1">
                  <a ngbNavLink (click)="toggleForm(1)">Login</a>

                  <ng-template ngbNavContent>
                    <ng-container *ngTemplateOutlet="loginForm; context: { form: form }" />
                  </ng-template>
                </li>

                <li [ngbNavItem]="2">
                  <a ngbNavLink (click)="toggleForm(2)">Masquerade</a>

                  <ng-template ngbNavContent>
                    <!-- Masqueradee Credentials (who user wants to masquerade as) -->
                    <fieldset class="border rounded p-3 mb-4">
                      <legend class="float-none m-0 w-auto fs-6 fw-normal display-5">
                        <span>Who you want to masquerade as?</span>
                      </legend>

                      <ng-container
                        *ngTemplateOutlet="loginForm; context: { form: form, masq: true }"
                      />
                    </fieldset>

                    <!-- Masquerader Credentials (who user logging in is) -->
                    <fieldset class="border rounded p-3">
                      <legend class="float-none m-0 w-auto fs-6 fw-normal display-5">
                        <span>Who you are (eg: SuperUser)</span>
                      </legend>

                      <div class="mb-3">
                        <label for="MasqueraderEmail" class="form-label required">
                          <span>Masquerader Email</span>
                        </label>
                        <input
                          id="MasqueraderEmail"
                          class="form-control"
                          type="email"
                          name="m_email"
                          formControlName="masqEmail"
                        />
                      </div>
                      <div>
                        <label for="MasqueraderPassword" class="form-label required">
                          <span>Masquerader Client Custom Code</span>
                        </label>
                        <input
                          id="MasqueraderPassword"
                          class="form-control"
                          type="text"
                          name="m_client"
                          formControlName="masqClientCustomCode"
                        />
                      </div>
                    </fieldset>
                  </ng-template>
                </li>
              </ul>

              <div [ngbNavOutlet]="nav" class="my-3"></div>

              <button
                class="btn w-100 text-light login"
                type="submit"
                [disabled]="form.invalid || login_btn_disabled"
              >
                Login
              </button>

              <button
                class="btn btn-primary w-100 text-light mt-3"
                type="submit"
                (click)="validateDirectLogin()"
                [disabled]="form.invalid || login_btn_disabled"
              >
                Direct Login
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #loginForm let-form="form" let-masq="masq">
  <div [formGroup]="form">
    <div class="mb-3">
      <label for="{{ masq ? 'masqEmail' : 'Email' }}" class="form-label required">Email</label>
      <input
        id="{{ masq ? 'masqEmail' : 'Email' }}"
        class="form-control"
        type="email"
        name="email"
        formControlName="email"
      />
    </div>
    <div>
      <label for="{{ masq ? 'masqClientCode' : 'ClientCode' }}" class="form-label required">
        Client Custom Code
      </label>
      <input
        id="{{ masq ? 'masqClientCode' : 'ClientCode' }}"
        class="form-control"
        type="text"
        name="clientcode"
        formControlName="clientCustomCode"
      />
    </div>
  </div>
</ng-template>
